const sPlusTitle = document.querySelectorAll(".product-right .section-plus h2");
const itemFormula = document.querySelectorAll(".formula .title");
const inciBtn = document.querySelector(".content-inci h4");
const variants = document.querySelectorAll(".content-select-variants .select-variants .variant");

function formatPrice(price, currency){
    switch(currency){
        case "EUR" : var devise = "€"; break;
        default : var devise = "€";  
    }
    return (parseInt(price) / 100).toFixed(2) + devise;
}


if(sPlusTitle.length > 0){
    sPlusTitle.forEach(t => {
        t.addEventListener("click", () => {
            var sectionPlus = t.closest(".section-plus");
            sectionPlus.classList.toggle("close");  
        });
    });
}



if(itemFormula.length > 0){
    itemFormula.forEach(i => {
        i.addEventListener("click", () => {
            var formula = i.closest(".formula");
            if(formula.querySelector(".description") != null){
                formula.classList.toggle("open");  
            }
        });
    });
}

if(inciBtn != null){
    inciBtn.addEventListener("click", () => {
        var cInci = inciBtn.closest(".content-inci");
        cInci.classList.toggle("open");  
    }); 
}


function addToCartFixedDesk(wScroll){ 
    //var promo = document.querySelector(".content-bandeau-promo");
    var targetPos = document.querySelector(".content-main-infos .content-add-to-cart").offsetTop;
    /*
    if(promo != null){
        var top = 81 + promo.offsetHeight; 
        document.querySelector(".content-add-to-cart-fixe").style.top = top + "px";
    }
    */
    if(wScroll > targetPos){
        document.querySelector(".content-add-to-cart-fixe").classList.add("show"); 
    }else{
        document.querySelector(".content-add-to-cart-fixe").classList.remove("show");
    }
}

if(document.querySelector(".content-add-to-cart-fixe") != null){
    window.addEventListener("scroll", () => {
        addToCartFixedDesk(window.scrollY);
    });
}

if(variants.length > 0){
    variants.forEach(variant => {
        variant.addEventListener("click", () => {
            if(!variant.classList.contains("selected")){
                var dataId = variant.getAttribute("data-id");
                document.querySelectorAll(".content-select-variants .select-variants .variant.selected").forEach(v => {
                    v.classList.remove("selected");
                });
                majProductData(variant.dataset); 
                document.querySelectorAll(".content-select-variants .select-variants .variant[data-id='" + dataId + "']").forEach(v => {
                    v.classList.add("selected");
                });
            }  
        });
    });
}

function majProductData(datas){ 
    document.querySelectorAll(".product-right .add-to-cart").forEach(addToCart => { 
        addToCart.setAttribute("data-vid", datas.id); 
        addToCart.querySelector(".contenance").textContent = datas.option;
        //document.querySelector(".main-infos h1 .contenance").innerHTML = datas.option; 
        if(datas.compareAtPrice != "" && parseInt(datas.compareAtPrice) > parseInt(datas.price)){
            addToCart.querySelector(".oldprice").innerHTML = datas.compareAtPriceWm;
        }else{
            addToCart.querySelector(".oldprice").innerHTML = "";
        }
        addToCart.querySelector(".price .currentprice").innerHTML = datas.priceWm;
    });
}


document.querySelector(".content-reviews-min").addEventListener("click", () => {
    var topContentReviews = document.querySelector(".content-reviews").offsetTop - document.querySelector("#header").offsetHeight;
    window.scroll(0, topContentReviews);
});

if(getParams("pour") != null && getParams("pour") == "lui"){
    document.querySelector("#product").classList.add("homme");
    document.querySelectorAll(".add-to-cart").forEach(btn => {
        btn.setAttribute("data-props", '{"pour":"lui"}');
    });
}  


document.querySelectorAll(".content-cat-produit .menu li").forEach(eMenu => {
    eMenu.addEventListener("click", () => { 
        if(!eMenu.classList.contains("active")){ 
            document.querySelector(".content-cat-produit .menu li.active").classList.remove("active");
            document.querySelector(".content-cat-produit .cat.active").classList.remove("active");
            let cat = eMenu.getAttribute("data-cat");
            document.querySelector(`.content-cat-produit .cat[data-cat=${cat}]`).classList.add("active");
            eMenu.classList.add("active");
        }
    });
});

document.querySelectorAll(".content-complement-list .content-list .list h3").forEach(t => {
    t.addEventListener("click", () => {
        t.closest("li").classList.toggle("open");
    });
});

document.querySelectorAll(".content-complement-list .content-list .list .blacklist ul li h5").forEach(item => {
    item.addEventListener("click", (e) => { 
        item.closest("li").classList.toggle("open");
    });
}); 

document.querySelectorAll(".content-skincare-list .content-list .list h3").forEach(t => {
    t.addEventListener("click", () => {
        t.closest("li").classList.toggle("open");
    });
});

document.querySelectorAll(".content-skincare-list .content-list .list .blacklist ul li h5").forEach(item => {
    item.addEventListener("click", (e) => { 
        item.closest("li").classList.toggle("open");
    });
}); 

document.querySelectorAll(".content-variants .variant").forEach(variant => {
    variant.addEventListener("click", (e) => {  
        if(!variant.classList.contains("current") && !variant.classList.contains("link") && !variant.classList.contains("out-of-stock")){
            document.querySelector(".content-variants .variant.current").classList.remove("current");
            variant.classList.add("current");
            let vid = variant.getAttribute("data-vid");
            let price = variant.getAttribute("data-price");
            let oldprice = variant.getAttribute("data-oldprice");
            let available = variant.getAttribute("data-available");
            let contenance = variant.getAttribute("data-contenance");
            let name = variant.getAttribute("data-name"); 
            document.querySelectorAll(".add-to-cart.page-product").forEach(atc => { 
                atc.querySelector(".price .currentprice").innerHTML = formatPrice(price);
                atc.setAttribute("data-vid", vid);
                atc.setAttribute("data-name", name);
                atc.setAttribute("data-price", price);
                if(oldprice > price){
                    atc.querySelector(".price .oldprice").innerHTML = formatPrice(oldprice);
                    atc.querySelector(".price .oldprice").classList.add("show");
                }else{
                    atc.querySelector(".price .oldprice").innerHTML = "";
                    if(atc.querySelector(".price .oldprice").classList.contains("show")){
                        atc.querySelector(".price .oldprice").classList.remove("show");
                    }
                }
                if(available == "true"){
                    if(atc.classList.contains("out-of-stock")){
                        atc.classList.remove("out-of-stock");
                    }
                }else{  
                    if(!atc.classList.contains("out-of-stock")){
                        atc.classList.add("out-of-stock");
                    }
                } 
                if(atc.querySelector(".contenance") != null){
                    atc.querySelector(".contenance").innerHTML = contenance;
                }
            }); 
        }
    });
}); 


const questions = document.querySelectorAll(".content-faq .q h3");

questions.forEach(i => {
    i.addEventListener("click", () => {
        var parent = i.closest(".q-r");
        parent.classList.toggle("open");  
    });
}); 

if(getParams("variant") != null){
    if(document.querySelector(".content-variants") != null){
        let vid = getParams("variant");
        document.querySelector(`.content-variants .variant[data-vid="${vid}"]`).click();
    }
}